<template>
    <!-- <v-flex  
      class="notification-message"
      :class="{ active: isActive }"
      :style="{ background: background }"
      >
        <div class="message-top-line"></div>
        <div class="py-2 px-5 message-text">
          <v-icon v-if="status === 'success'" class="mr-2 message-icon">mdi-check-circle</v-icon> 
          <v-icon v-if="status === 'error'" class="mr-2 message-icon">mdi-alert</v-icon> 
          {{ text }}</div>
    </v-flex> -->
    <v-snackbar
      v-model="isActive"
      :color="status"
      :timeout="timeout"
      bottom
      :multi-line="$vuetify.breakpoint.xs"
    > 
      <div class="message-text">
      <v-icon v-if="status === 'success'" class="mr-2 message-icon">mdi-check-circle</v-icon> 
      <v-icon v-if="status === 'error'" class="mr-2 message-icon">mdi-alert</v-icon> 
      {{ text }}
      </div>
      <v-btn
        icon
        @click="isActive = false"
      >
        <v-icon class="message-icon">mdi-close-thick</v-icon>
      </v-btn>
    </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      timeout: 4000,
      text: '',
      background: '',
      status: ''
    }
  },
  created() {
    this.$root.$on('notification', (data) => {
      this.isActive = true;
      this.text = data.text;
      this.status = data.status
      if(data.status === 'success'){
        this.background = '#4baf50';
      } else if (data.status === 'error') {
        this.background = '#ff5252';
      }
    
      // setTimeout(
      //   () => {
      //     this.isActive = false
      //   }, this.timeout
      // )
    })
  },
  beforeDestroy () {
    this.$root.$off('notification', () => {
    })
  }
}
</script>

<style scoped>
  .notification-message {
    color: #fff;
    position: fixed; 
    width: 100%; 
    z-index: 5; 
    transform: translateY(-100%); 
    transition: transform .4s ease;
  }
  .message-top-line {
    height: 4px; background: rgba(0, 0, 0, .1);
  }
  .message-text {
    font-size: 14px;
  }
  .message-icon {
    color: black; opacity: .5; font-size: 17px;
  }
  .v-snack__wrapper {
    max-width: inherit!important;
    min-width: inherit!important;
    width: 100%!important;
  }
  .active {
    transform: translateY(0%)!important;
  }
</style>

